import React from "react";
import { legalCss, SiteNav, SiteFooter, LegalPreloader } from "../components/LegalChrome";

const Confidentialitate = () => {
  return (
    <div className="lg-root">
      <style>{legalCss}</style>
      <LegalPreloader />
      <div className="lg-grain" />

      <SiteNav />

      <section className="lg-hero">
        <div className="lg-label">Aware</div>
        <h1>Politica de Confidențialitate</h1>
        <div className="lg-updated">Ultima actualizare: 3 septembrie 2026</div>
      </section>

      <div className="lg-body">
        <p className="lg-intro">
          Acest site este operat de <strong>Antonescu și Asociații — Societate Civilă Profesională de Psihologie</strong>,
          CUI 42449928, Constanța ("Aware", "noi"). Mai jos explicăm simplu ce date colectăm și cum le folosim.
        </p>

        <div className="lg-sec">
          <div className="lg-sec-num">01</div>
          <h2>Despre acest site</h2>
          <p>
            awaretherapycenter.ro prezintă centrul Aware și cei patru psihologi din echipă — servicii,
            specializări, evenimente.
          </p>
          <p>
            <strong>Programările nu se fac prin site.</strong> Se stabilesc direct, telefonic sau prin
            email. Nu colectăm și nu păstrăm nimic despre motivul programării sau despre sănătatea dvs.
          </p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">02</div>
          <h2>Ce date colectăm</h2>
          <p>Doar dacă vă creați un cont:</p>
          <ul>
            <li>Nume și email, la înregistrare.</li>
            <li>Dacă vă logați cu Google, primim numele și emailul din contul Google.</li>
            <li>O informație tehnică ce vă păstrează sesiunea autentificată în browser.</li>
          </ul>
          <p>Nu folosim cookie-uri de analiză sau publicitate.</p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">03</div>
          <h2>De ce le folosim</h2>
          <ul>
            <li>Ca să vă administrăm contul.</li>
            <li>Pentru newsletter — <strong>doar dacă vă abonați explicit</strong>. Vă dezabonați oricând, dintr-un link din email.</li>
            <li>Ca să respectăm obligațiile legale.</li>
          </ul>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">04</div>
          <h2>Cine are acces</h2>
          <p>
            Doar personalul autorizat Aware. Nu vindem și nu distribuim datele către terți. La login
            cu Google, Google prelucrează datele conform propriei politici, ca operator separat.
          </p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">05</div>
          <h2>Cât timp le păstrăm</h2>
          <p>
            Cât timp contul e activ. Puteți cere oricând ștergerea contului și a datelor, la contactul
            de mai jos.
          </p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">06</div>
          <h2>Drepturile dumneavoastră</h2>
          <p>Conform GDPR, aveți dreptul la:</p>
          <ul>
            <li>Acces la datele deținute despre dvs.</li>
            <li>Rectificarea datelor greșite.</li>
            <li>Ștergerea datelor.</li>
            <li>Restricționarea prelucrării.</li>
            <li>Portabilitatea datelor.</li>
            <li>Retragerea consimțământului oricând.</li>
          </ul>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">07</div>
          <h2>Modificări</h2>
          <p>Putem actualiza periodic această pagină. Data de mai sus arată ultima actualizare.</p>
        </div>

        <div className="lg-contact-box">
          <p><strong>Pentru orice solicitare privind datele dumneavoastră:</strong></p>
          <p>Email: <a href="mailto:psihologie.aware@gmail.com">psihologie.aware@gmail.com</a></p>
          <p>Telefon: <a href="tel:+40723071922">+40 723 071 922</a></p>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};

export default Confidentialitate;
